// tslint:disable:no-any
// tslint:disable:no-string-literal
import React, { Component } from 'react';

import { AuthLogic } from '../../auth/AuthLogic';
import { DisplayDate } from '../../components/Display';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import { isUniqueMessage } from '../../components/Messages';
import Title from '../../components/Title';
import { ProfileService } from '../../services/ProfileService';
import { ISettings } from '../../services/SettingsService';
import Dt from 'react-document-title';
import { NavigationStore } from '../Navigation/NavigationStore';
import { UserSettingsDTO } from '../../api';

// import Navigation from '../../components/Navigation';
export interface ISettingsProps {}

interface ISettingsState {
    active: string;
    profileLoaded: boolean;
    avatar: any;
    dateRegistered: any;
    nickname: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    contactEmail: string | undefined;
    canChangePassword: boolean;
    password: string;
    passwordConfirmation: string;
    settings: any;
    messages: any;
    validFields: any;
}

class Settings extends Component<ISettingsProps, ISettingsState> {
    constructor(props: ISettingsProps) {
        super(props);
        this.state = {
            // stranka
            active: 'personalData',
            // personal data
            profileLoaded: false,
            avatar: null,
            dateRegistered: null,
            nickname: '',
            name: '',
            surname: '',
            contactEmail: '',
            // moznost zmeny hesla
            canChangePassword: false,
            // hesla
            password: '',
            passwordConfirmation: '',
            // nastaveni
            settings: [],
            // zpravy
            messages: [],
            // overeni formulare
            validFields: {}
        };
    }

    public async componentDidMount() {
        const profile = await ProfileService.getInstance().reloadProfile();
        if (profile != undefined && (profile as ISettings) != undefined) {
            const temp = profile as ISettings;
            this.setState({
                profileLoaded: true,
                dateRegistered: temp.dateRegistered,
                nickname: temp.nickname,
                name: temp.name,
                surname: temp.surname,
                contactEmail: temp.contactEmail,
                settings: temp.config
            });
        }

        NavigationStore.getInstance().setActive('settings');
        window.scrollTo(0, 0);
    }

    prepareValid() {
        let newValidFields: any = {};

        // validace osobnich dat
        if (this.isPersonalDataPage()) {
            // newValidFields.nickname = (this.state.nickname ? true : false);
            newValidFields.name = this.state.name ? true : false;
            newValidFields.surname = this.state.surname ? true : false;
            newValidFields.contactEmail = this.state.contactEmail
                ? true
                : false;

            // state
            this.setState({
                validFields: newValidFields
            });

            return (
                /*newValidFields.nickname && */ newValidFields.name &&
                newValidFields.surname &&
                newValidFields.contactEmail
            );
        }

        // validace hesla
        if (this.isPasswordPage()) {
            newValidFields.password =
                this.isPasswordPage() && this.state.password ? true : false;
            newValidFields.passwordConfirmation =
                this.isPasswordPage() && this.state.passwordConfirmation
                    ? this.state.password === this.state.passwordConfirmation
                    : false;

            // state
            this.setState({
                validFields: newValidFields
            });

            return (
                newValidFields.password && newValidFields.passwordConfirmation
            );
        }

        // state
        this.setState({
            validFields: newValidFields
        });

        return false;
    }

    renewToken() {
        AuthLogic.getInstance().renew();
    }

    isPersonalDataPage() {
        return this.state.active === 'personalData';
    }

    isUnitsDataPage() {
        return this.state.active === 'units';
    }

    isPasswordPage() {
        return this.state.active === 'password';
    }

    handleClick(item: string) {
        this.setState({
            active: item
        });
    }

    addMessage(text: string, type: string) {
        if (isUniqueMessage(text, this.state.messages)) {
            let newMessages = [...this.state.messages];
            newMessages.push({
                text: text,
                value: null,
                type: type
            });
            this.setState({
                messages: newMessages
            });
        }
    }

    onClickMessage(e?: any) {
        this.setState({
            messages: []
        });
    }

    onChangeData(event: any) {
        let newState = this.state;
        newState[event.target.name] = event.target.value;
        this.setState(newState, () => {
            this.prepareValid();
        });
    }

    onChangeSettins(event: any) {
        let newSettings = this.state.settings;
        newSettings[event.target.name] = event.target.value;
        this.setState({
            settings: newSettings
        });
    }

    async savePersonalData() {
        if (this.prepareValid()) {
            const data = {
                nickname: this.state.nickname,
                name: this.state.name,
                surname: this.state.surname,
                contactEmail: this.state.contactEmail
            };

            const response = await ProfileService.getInstance().updateProfilePersonalData(
                data as any
            );

            if (response == undefined) {
                return;
            }

            switch (response.status) {
                case 400:
                    this.addMessage('Bad request', 'error');
                    break;
                case 200:
                    this.addMessage('Settings saved successfully', 'success');
                    await ProfileService.getInstance().reloadProfile();
                    break;
                default:
                    this.addMessage('Your profile was not found', 'error');
                    break;
            }
        }
    }

    async saveSettingsData() {
        const settings = this.state.settings;

        const response = await ProfileService.getInstance().updateProfileSettings(
            settings
        );

        if (response == undefined) {
            return;
        }

        switch (response.status) {
            case 400:
                this.addMessage('Bad request', 'error');
                break;
            case 200:
                this.addMessage('Settings saved successfully', 'success');
                break;
            default:
                this.addMessage('Your profile was not found', 'error');
                break;
        }
    }

    onChangePassword(e: any) {
        let newPassword = this.state.password;
        let newPasswordConfirmation = this.state.passwordConfirmation;

        if (e.target.name === 'password') {
            newPassword = e.target.value;
        }

        if (e.target.name === 'passwordConfirmation') {
            newPasswordConfirmation = e.target.value;
        }

        this.setState(
            {
                password: newPassword,
                passwordConfirmation: newPasswordConfirmation
            },
            () => {
                this.prepareValid();
            }
        );
    }

    async saveChangePassword() {
        if (this.prepareValid()) {
            const data = {
                password: this.state.password,
                passwordConfirmation: this.state.passwordConfirmation
            };
            const response = await ProfileService.getInstance().updateProfilePassword(
                data
            );

            if (response == undefined) {
                return;
            }

            switch (response.status) {
                case 400:
                    this.addMessage('Bad request', 'error');
                    break;
                case 200:
                    this.setState({
                        password: '',
                        passwordConfirmation: ''
                    });
                    this.addMessage(
                        'Your password has been successfully saved',
                        'success'
                    );
                    break;
                default:
                    this.addMessage('Your profile was not found', 'error');
                    break;
            }
        }
    }

    render() {
        if (this.state.profileLoaded === false) {
            return <Loader />;
        }

        return (
            <Dt title={'WetNotes | My account'}>
                <div className="settings">
                    <Title
                        heading={'Settings'}
                        breadcrumbs={[
                            { caption: 'Personal Data', to: '/app/settings' }
                        ]}
                    />

                    <div className="wrapper">
                        <div className="col__sidebar">
                            <div className="sidebarMenu">
                                <div
                                    className={
                                        'sidebarMenu__item' +
                                        (this.state.active === 'personalData'
                                            ? ' current'
                                            : '')
                                    }
                                    onClick={() =>
                                        this.handleClick('personalData')
                                    }
                                >
                                    Personal Data
                                </div>
                                <div
                                    className={
                                        'sidebarMenu__item' +
                                        (this.state.active === 'units'
                                            ? ' current'
                                            : '')
                                    }
                                    onClick={() => this.handleClick('units')}
                                >
                                    Users Settings
                                </div>
                                {this.state.canChangePassword && (
                                    <div
                                        className={
                                            'sidebarMenu__item' +
                                            (this.state.active === 'password'
                                                ? ' current'
                                                : '')
                                        }
                                        onClick={() =>
                                            this.handleClick('password')
                                        }
                                    >
                                        Change Password
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="col__main">
                            {this.state.messages.length > 0 && (
                                <div className="messages">
                                    {this.state.messages.map(
                                        (message: any, index: number) => {
                                            return (
                                                <Message
                                                    key={index}
                                                    text={message.text}
                                                    type={message.type}
                                                    value={message.value}
                                                    autoClose={true}
                                                    onClose={() =>
                                                        this.onClickMessage()
                                                    }
                                                />
                                            );
                                        }
                                    )}
                                </div>
                            )}

                            {this.state.active === 'personalData' && (
                                <div className="standardContainer">
                                    <div className="standardContainer__header">
                                        <h3>Personal Data</h3>
                                    </div>

                                    <div className="standardContainer__body">
                                        <div className="form--profile">
                                            <div className="form--profile__pictureArea hidden">
                                                <h3>Profile image:</h3>

                                                <div className="form--profile__pictureArea__img">
                                                    {this.state.avatar !==
                                                    null ? (
                                                        <img
                                                            src={
                                                                this.state
                                                                    .avatar
                                                            }
                                                            alt=""
                                                        />
                                                    ) : (
                                                        <img
                                                            src="https://placeholdit.co//i/555x150"
                                                            alt=""
                                                        />
                                                    )}
                                                </div>

                                                <div className="form--profile__pictureArea__imgLabel">
                                                    <p>Foto-1.jpg</p>
                                                    <p>192 kB</p>

                                                    <button
                                                        className="btn btn--borderGray btn--colorRed btn--smallpill"
                                                        onClick={() =>
                                                            this.renewToken()
                                                        }
                                                    >
                                                        Change
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="form--profile__formArea form">
                                                <h3 className="hidden">
                                                    Personal data:
                                                </h3>

                                                {this.state.dateRegistered && (
                                                    <div>
                                                        <p className="inputLabel">
                                                            Registered:
                                                        </p>
                                                        <span className="dateRegistered">
                                                            <DisplayDate
                                                                data={
                                                                    this.state
                                                                        .dateRegistered
                                                                }
                                                            />
                                                        </span>
                                                    </div>
                                                )}

                                                <div
                                                    className={
                                                        this.state.validFields[
                                                            'nickname'
                                                        ] !== undefined &&
                                                        this.state.validFields[
                                                            'nickname'
                                                        ] !== true
                                                            ? 'error'
                                                            : ''
                                                    }
                                                >
                                                    <p className="inputLabel">
                                                        Nick:
                                                    </p>
                                                    <input
                                                        type="text"
                                                        name="nickname"
                                                        value={
                                                            this.state.nickname
                                                        }
                                                        onChange={e =>
                                                            this.onChangeData(e)
                                                        }
                                                    />
                                                    {this.state.validFields[
                                                        'nickname'
                                                    ] !== undefined &&
                                                        this.state.validFields[
                                                            'nickname'
                                                        ] !== true && (
                                                            <div className="alert">
                                                                Enter your
                                                                nickname
                                                            </div>
                                                        )}
                                                </div>

                                                <div
                                                    className={
                                                        this.state.validFields[
                                                            'name'
                                                        ] !== undefined &&
                                                        this.state.validFields[
                                                            'name'
                                                        ] !== true
                                                            ? 'error'
                                                            : ''
                                                    }
                                                >
                                                    <p className="inputLabel">
                                                        Name:
                                                    </p>
                                                    <input
                                                        type="text"
                                                        name="name"
                                                        value={this.state.name}
                                                        onChange={e =>
                                                            this.onChangeData(e)
                                                        }
                                                    />
                                                    {this.state.validFields[
                                                        'name'
                                                    ] !== undefined &&
                                                        this.state.validFields[
                                                            'name'
                                                        ] !== true && (
                                                            <div className="alert">
                                                                Enter your name
                                                            </div>
                                                        )}
                                                </div>

                                                <div
                                                    className={
                                                        this.state.validFields[
                                                            'surname'
                                                        ] !== undefined &&
                                                        this.state.validFields[
                                                            'surname'
                                                        ] !== true
                                                            ? 'error'
                                                            : ''
                                                    }
                                                >
                                                    <p className="inputLabel">
                                                        Surname:
                                                    </p>
                                                    <input
                                                        type="text"
                                                        name="surname"
                                                        value={
                                                            this.state.surname
                                                        }
                                                        onChange={e =>
                                                            this.onChangeData(e)
                                                        }
                                                    />
                                                    {this.state.validFields[
                                                        'surname'
                                                    ] !== undefined &&
                                                        this.state.validFields[
                                                            'surname'
                                                        ] !== true && (
                                                            <div className="alert">
                                                                Enter your
                                                                surname
                                                            </div>
                                                        )}
                                                </div>

                                                <div
                                                    className={
                                                        this.state.validFields[
                                                            'contactEmail'
                                                        ] !== undefined &&
                                                        this.state.validFields[
                                                            'contactEmail'
                                                        ] !== true
                                                            ? 'error'
                                                            : ''
                                                    }
                                                >
                                                    <p className="inputLabel">
                                                        E-mail:
                                                    </p>
                                                    <input
                                                        type="email"
                                                        name="contactEmail"
                                                        value={
                                                            this.state
                                                                .contactEmail
                                                        }
                                                        onChange={e =>
                                                            this.onChangeData(e)
                                                        }
                                                    />
                                                    {this.state.validFields[
                                                        'contactEmail'
                                                    ] !== undefined &&
                                                        this.state.validFields[
                                                            'contactEmail'
                                                        ] !== true && (
                                                            <div className="alert">
                                                                Enter your
                                                                contact e-mail
                                                            </div>
                                                        )}
                                                </div>

                                                <button
                                                    className="btn btn--borderGray btn--colorRed btn--smallpill"
                                                    onClick={() =>
                                                        this.savePersonalData()
                                                    }
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {this.state.active === 'units' && (
                                <div className="standardContainer">
                                    <div className="standardContainer__header">
                                        <h3>User Settings</h3>
                                    </div>

                                    <div className="standardContainer__body">
                                        <div className="form--units">
                                            <div className="form--units__holder">
                                                <span className="form--units__holder__label">
                                                    Length:
                                                </span>
                                                <div className="form--units__holder__item">
                                                    <input
                                                        type="radio"
                                                        id="unitOfLengthMetre"
                                                        name="unitOfLength"
                                                        value="metre"
                                                        checked={
                                                            this.state.settings
                                                                .unitOfLength !==
                                                            'foot'
                                                        }
                                                        onChange={e =>
                                                            this.onChangeSettins(
                                                                e
                                                            )
                                                        }
                                                    />
                                                    <label htmlFor="unitOfLengthMetre">
                                                        <span />metre
                                                    </label>
                                                </div>

                                                <div className="form--units__holder__item">
                                                    <input
                                                        type="radio"
                                                        id="unitOfLengthFoot"
                                                        name="unitOfLength"
                                                        value="foot"
                                                        checked={
                                                            this.state.settings
                                                                .unitOfLength ===
                                                            'foot'
                                                        }
                                                        onChange={e =>
                                                            this.onChangeSettins(
                                                                e
                                                            )
                                                        }
                                                    />
                                                    <label htmlFor="unitOfLengthFoot">
                                                        <span />foot
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="form--units__holder">
                                                <span className="form--units__holder__label">
                                                    Pressure:
                                                </span>
                                                <div className="form--units__holder__item">
                                                    <input
                                                        type="radio"
                                                        id="unitOfPressureBar"
                                                        name="unitOfPressure"
                                                        value="bar"
                                                        checked={
                                                            this.state.settings
                                                                .unitOfPressure !==
                                                            'poundPerSquareInch'
                                                        }
                                                        onChange={e =>
                                                            this.onChangeSettins(
                                                                e
                                                            )
                                                        }
                                                    />
                                                    <label htmlFor="unitOfPressureBar">
                                                        <span />bar
                                                    </label>
                                                </div>

                                                <div className="form--units__holder__item">
                                                    <input
                                                        type="radio"
                                                        id="unitOfPressurePsi"
                                                        name="unitOfPressure"
                                                        value="poundPerSquareInch"
                                                        checked={
                                                            this.state.settings
                                                                .unitOfPressure ===
                                                            'poundPerSquareInch'
                                                        }
                                                        onChange={e =>
                                                            this.onChangeSettins(
                                                                e
                                                            )
                                                        }
                                                    />
                                                    <label htmlFor="unitOfPressurePsi">
                                                        <span />psi
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="form--units__holder">
                                                <span className="form--units__holder__label">
                                                    Temperature:
                                                </span>
                                                <div className="form--units__holder__item">
                                                    <input
                                                        type="radio"
                                                        id="unitOfTemperatureC"
                                                        name="unitOfTemperature"
                                                        value="celsius"
                                                        checked={
                                                            this.state.settings
                                                                .unitOfTemperature !==
                                                            'fahrenheit'
                                                        }
                                                        onChange={e =>
                                                            this.onChangeSettins(
                                                                e
                                                            )
                                                        }
                                                    />
                                                    <label htmlFor="unitOfTemperatureC">
                                                        <span />°C
                                                    </label>
                                                </div>

                                                <div className="form--units__holder__item">
                                                    <input
                                                        type="radio"
                                                        id="unitOfTemperatureF"
                                                        name="unitOfTemperature"
                                                        value="fahrenheit"
                                                        checked={
                                                            this.state.settings
                                                                .unitOfTemperature ===
                                                            'fahrenheit'
                                                        }
                                                        onChange={e =>
                                                            this.onChangeSettins(
                                                                e
                                                            )
                                                        }
                                                    />
                                                    <label htmlFor="unitOfTemperatureF">
                                                        <span />°F
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="form--units__holder">
                                                <span className="form--units__holder__label">
                                                    Mass:
                                                </span>
                                                <div className="form--units__holder__item">
                                                    <input
                                                        type="radio"
                                                        id="unitOfMassK"
                                                        name="unitOfMass"
                                                        value="kilogram"
                                                        checked={
                                                            this.state.settings
                                                                .unitOfMass !==
                                                            'pound'
                                                        }
                                                        onChange={e =>
                                                            this.onChangeSettins(
                                                                e
                                                            )
                                                        }
                                                    />
                                                    <label htmlFor="unitOfMassK">
                                                        <span />kilogram
                                                    </label>
                                                </div>

                                                <div className="form--units__holder__item">
                                                    <input
                                                        type="radio"
                                                        id="unitOfMassP"
                                                        name="unitOfMass"
                                                        value="pound"
                                                        checked={
                                                            this.state.settings
                                                                .unitOfMass ===
                                                            'pound'
                                                        }
                                                        onChange={e =>
                                                            this.onChangeSettins(
                                                                e
                                                            )
                                                        }
                                                    />
                                                    <label htmlFor="unitOfMassP">
                                                        <span />pound
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="form--units__holder">
                                                <span className="form--units__holder__label">
                                                    Volume:
                                                </span>
                                                <div className="form--units__holder__item">
                                                    <input
                                                        type="radio"
                                                        id="unitOfVolumeL"
                                                        name="unitOfVolume"
                                                        value="liter"
                                                        checked={
                                                            this.state.settings
                                                                .unitOfVolume !==
                                                            'cubicFoot'
                                                        }
                                                        onChange={e =>
                                                            this.onChangeSettins(
                                                                e
                                                            )
                                                        }
                                                    />
                                                    <label htmlFor="unitOfVolumeL">
                                                        <span />liter
                                                    </label>
                                                </div>

                                                <div className="form--units__holder__item">
                                                    <input
                                                        type="radio"
                                                        id="unitOfVolumeC"
                                                        name="unitOfVolume"
                                                        value="cubicFoot"
                                                        checked={
                                                            this.state.settings
                                                                .unitOfVolume ===
                                                            'cubicFoot'
                                                        }
                                                        onChange={e =>
                                                            this.onChangeSettins(
                                                                e
                                                            )
                                                        }
                                                    />
                                                    <label htmlFor="unitOfVolumeC">
                                                        <span />cuft
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="form--units__holder">
                                                <span className="form--units__holder__label">
                                                    Format:
                                                </span>
                                                <div className="form--units__holder__item">
                                                    <input
                                                        type="radio"
                                                        id="dateFormatY"
                                                        name="dateFormat"
                                                        value={UserSettingsDTO.DateFormatEnum.YMD}
                                                        checked={
                                                            this.state.settings
                                                                .dateFormat.toLowerCase() === UserSettingsDTO
                                                                    .DateFormatEnum.YMD.toString().toLowerCase()
                                                        }
                                                        onChange={e =>
                                                            this.onChangeSettins(
                                                                e
                                                            )
                                                        }
                                                    />
                                                    <label htmlFor="dateFormatY">
                                                        <span />Y-M-D
                                                    </label>
                                                </div>

                                                <div className="form--units__holder__item">
                                                    <input
                                                        type="radio"
                                                        id="dateFormatD"
                                                        name="dateFormat"
                                                        value={UserSettingsDTO.DateFormatEnum.DMY}
                                                        checked={
                                                            this.state.settings
                                                                .dateFormat.toLowerCase() === UserSettingsDTO
                                                                    .DateFormatEnum.DMY.toString().toLowerCase() ||
                                                            this.state.settings
                                                                .dateFormat.toLowerCase() !== UserSettingsDTO
                                                                    .DateFormatEnum.YMD.toString().toLowerCase() ||
                                                            this.state.settings
                                                                .dateFormat.toLowerCase() === UserSettingsDTO
                                                                    .DateFormatEnum.MDY.toString().toLowerCase()
                                                        }
                                                        onChange={e =>
                                                            this.onChangeSettins(
                                                                e
                                                            )
                                                        }
                                                    />
                                                    <label htmlFor="dateFormatD">
                                                        <span />D.M.Y
                                                    </label>
                                                </div>

                                                <div className="form--units__holder__item">
                                                    <input
                                                        type="radio"
                                                        id="dateFormatM"
                                                        name="dateFormat"
                                                        value={UserSettingsDTO.DateFormatEnum.MDY}
                                                        checked={
                                                            this.state.settings
                                                                .dateFormat.toLowerCase() === UserSettingsDTO
                                                                    .DateFormatEnum.MDY.toString().toLowerCase()
                                                        }
                                                        onChange={e =>
                                                            this.onChangeSettins(
                                                                e
                                                            )
                                                        }
                                                    />
                                                    <label htmlFor="dateFormatM">
                                                        <span />M/D/Y
                                                    </label>
                                                </div>
                                            </div>

                                            <button
                                                className="btn btn--smallpill btn--colorRed btn--borderGray"
                                                onClick={() =>
                                                    this.saveSettingsData()
                                                }
                                            >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {this.state.active === 'password' &&
                                this.state.canChangePassword && (
                                    <div className="standardContainer">
                                        <div className="standardContainer__header">
                                            <h3>Change Password</h3>
                                        </div>

                                        <div className="standardContainer__body">
                                            <div className="form form--password">
                                                <div
                                                    className={
                                                        this.state.validFields[
                                                            'password'
                                                        ] !== undefined &&
                                                        this.state.validFields[
                                                            'password'
                                                        ] !== true
                                                            ? 'error'
                                                            : ''
                                                    }
                                                >
                                                    <p className="inputLabel">
                                                        Password:
                                                    </p>
                                                    <div>
                                                        <input
                                                            type="password"
                                                            name="password"
                                                            value={
                                                                this.state
                                                                    .password
                                                            }
                                                            onChange={e =>
                                                                this.onChangePassword(
                                                                    e
                                                                )
                                                            }
                                                        />
                                                        {this.state.validFields[
                                                            'password'
                                                        ] !== undefined &&
                                                            this.state
                                                                .validFields[
                                                                'password'
                                                            ] !== true && (
                                                                <div className="alert">
                                                                    Enter
                                                                    password
                                                                </div>
                                                            )}
                                                    </div>
                                                </div>

                                                <div
                                                    className={
                                                        this.state.validFields[
                                                            'passwordConfirmation'
                                                        ] !== undefined &&
                                                        this.state.validFields[
                                                            'passwordConfirmation'
                                                        ] !== true
                                                            ? 'error'
                                                            : ''
                                                    }
                                                >
                                                    <p className="inputLabel">
                                                        Confirm Password:
                                                    </p>
                                                    <div>
                                                        <input
                                                            type="password"
                                                            name="passwordConfirmation"
                                                            value={
                                                                this.state
                                                                    .passwordConfirmation
                                                            }
                                                            onChange={e =>
                                                                this.onChangePassword(
                                                                    e
                                                                )
                                                            }
                                                        />
                                                        {this.state.validFields[
                                                            'passwordConfirmation'
                                                        ] !== undefined &&
                                                            this.state
                                                                .validFields[
                                                                'passwordConfirmation'
                                                            ] !== true && (
                                                                <div className="alert">
                                                                    Enter
                                                                    confirm
                                                                    password
                                                                </div>
                                                            )}
                                                    </div>
                                                </div>

                                                <button
                                                    className="btn btn--smallpill btn--colorRed btn--borderRed"
                                                    onClick={e =>
                                                        this.saveChangePassword()
                                                    }
                                                >
                                                    Change password
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                        </div>
                    </div>
                </div>
            </Dt>
        );
    }
}

export default Settings;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Settings/Settings.tsx